import { createSelector } from '@ngrx/store'

export const getUISettingsState = createSelector(
  (state: any) => state.uiSettings,
  (state: any) => state,
)
